import { render, staticRenderFns } from "./LocationDetail.vue?vue&type=template&id=311a2e82&scoped=true&"
import script from "./LocationDetail.vue?vue&type=script&lang=js&"
export * from "./LocationDetail.vue?vue&type=script&lang=js&"
import style0 from "./LocationDetail.vue?vue&type=style&index=0&id=311a2e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a2e82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VContainer,VIcon,VRow})
